export { default } from "./GoogleMap";
export { default as googleMap } from "./GoogleMap";
